import { ChangeDetectorRef, Component, ViewContainerRef, Input, OnInit, OnChanges } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Router } from '@angular/router';

import { environment } from 'environments/environment';

import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';

import { Task } from 'app/shared/models/task.model';

@Component({
  selector: 'tasks-mine-widget',
  templateUrl: './task-widget.component.html'
})

/**
 * Widget component for My Tasks on Dasboard.
 */
export class TaskWidgetComponent implements OnInit {

  @Input() myTasks: Array<Task>;

  tasks: Array<Object>;
  dialogRef: MdDialogRef<any>;

  selectedIndex = 0;

  // Constructor method
  constructor(
    private viewContainerRef: ViewContainerRef,
    private cookieService: CookieService,
    private dialog: MdDialog,
    private router: Router) { }

  ngOnInit() {
    this.updateTaskList();
  }

  ngOnChanges() {
    this.updateTaskList();
  }

  updateTaskList() {
    this.tasks = [
      { name: 'My Tasks', values: this.myTasks },
    ];
  }

  onTaskDetailsChange(editResponse: Object) {
    if (!editResponse['isSubmitted']) {
      if (editResponse['tab'] === 'MyTasks') {
        this.myTasks.push(editResponse['task']);
      } else {
        this.myTasks.splice(this.myTasks.indexOf(editResponse['task']), 1);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/task/taskwidget/task-widget.component.ts